import axios from "axios";
import { logout } from "./auth";
import { toast } from "react-hot-toast";

const API = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("qqc_userToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error?.response?.data?.message;

    if (
      error.response?.status === 401 &&
      (message === "Invalid or expired token" ||
        message === "Not authorized to access this route. Please log in.")
    ) {
      toast.error("Session expired. Please login again.");

      logout();

      window.location.href = "/";
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
